import { IListItem, IMenuList } from '~/src/dash/types/menuList';
import { IntEnumToArray } from '~/src/dash/utils/utils_enum';

export interface IDeviceType {
  key: string;
  text: string;
}

// NOTE: The key directly applies to the SQL builder, don't change unless necessary
export const deviceTypes: IDeviceType[] = [
  {
    key: 'PERSONAL_COMPUTER',
    text: 'Desktop',
  },
  {
    key: 'CONNECTED_TV',
    text: 'Connected TV',
  },
  {
    key: 'HIGHEND_PHONE',
    text: 'Mobile',
  },
  {
    key: 'TABLET',
    text: 'Tablet',
  },
  {
    key: 'CONNECTED_DEVICE',
    text: 'Connected Device',
  },
  {
    key: 'SET_TOP_BOX',
    text: 'Set-Top Box',
  },
];

export const allDeviceTypes: IDeviceType[] = [
  {
    key: 'DEVICETYPE_UNKNOWN',
    text: 'Unknown Device Type',
  },
  {
    key: 'PERSONAL_COMPUTER',
    text: 'Desktop',
  },
  {
    key: 'CONNECTED_TV',
    text: 'Connected TV',
  },
  {
    key: 'HIGHEND_PHONE',
    text: 'Mobile',
  },
  {
    key: 'TABLET',
    text: 'Tablet',
  },
  {
    key: 'CONNECTED_DEVICE',
    text: 'Connected Device',
  },
  {
    key: 'SET_TOP_BOX',
    text: 'Set-Top Box',
  },
];

export function createAllDeviceTypesMenuList(): IMenuList {
  const out = {} as IMenuList;
  allDeviceTypes.forEach((dT) => {
    out[dT.key] = {
      ID: dT.key,
      selected: false,
      title: dT.text,
    };
  });
  return out;
}

// Used for Bidder and Campaign targeting
export const deviceORTBTypes: IDeviceType[] = [
  {
    key: '0',
    text: 'Unknown Device Type',
  },
  {
    key: '2',
    text: 'Desktop',
  },
  {
    key: '3',
    text: 'Connected TV',
  },
  {
    key: '4',
    text: 'Mobile',
  },
  {
    key: '5',
    text: 'Tablet',
  },
  {
    key: '6',
    text: 'Connected Device',
  },
  {
    key: '7',
    text: 'Set-Top Box',
  },
];

export function getDeviceTypesTextFromKey(key: string): string {
  return (deviceORTBTypes.find((deviceType: IDeviceType) => deviceType.key === key) || { text: '' })
    .text;
}

export enum EDeviceTypes {
  DEVICETYPE_UNKNOWN = 0,
  MOBILE = 1,
  PERSONAL_COMPUTER = 2,
  CONNECTED_TV = 3,
  HIGHEND_PHONE = 4,
  TABLET = 5,
  CONNECTED_DEVICE = 6,
  SET_TOP_BOX = 7,
}
export const EDeviceTypesValues = IntEnumToArray(EDeviceTypes);

export function EDeviceTypesToString(e: EDeviceTypes): string {
  switch (e) {
    case EDeviceTypes.DEVICETYPE_UNKNOWN:
      return 'Unknown Device Type';
    case EDeviceTypes.MOBILE:
      return 'Mobile';
    case EDeviceTypes.PERSONAL_COMPUTER:
      return 'Desktop';
    case EDeviceTypes.CONNECTED_TV:
      return 'Connected TV';
    case EDeviceTypes.HIGHEND_PHONE:
      return 'Highend Phone';
    case EDeviceTypes.TABLET:
      return 'Tablet';
    case EDeviceTypes.CONNECTED_DEVICE:
      return 'Connected Device';
    case EDeviceTypes.SET_TOP_BOX:
      return 'Set-Top Box';
  }
  return 'Unknown Device Type';
}

export function generateDeviceTypeMenuList(): IMenuList {
  const deviceTypeList = {} as IMenuList;
  for (const d of deviceORTBTypes) {
    deviceTypeList[d.key] = {
      selected: false,
      ID: d.key,
      title: d.text,
    } as IListItem;
  }

  return deviceTypeList;
}

export function genDeviceTypeMenuListWithSelectedAndDisable(
  deviceIDs: string,
  disabledIDs?: string[],
): IMenuList {
  const deviceTypeList = generateDeviceTypeMenuList();

  for (const selected of deviceIDs.split(',')) {
    if (deviceTypeList[selected]) {
      deviceTypeList[selected].selected = true;
    }
  }

  if ((disabledIDs || []).length) {
    for (const disabled of disabledIDs || []) {
      if (deviceTypeList[disabled]) {
        deviceTypeList[disabled].disabled = true;
      }
    }
  }

  return deviceTypeList;
}

export const allDeviceTypeEnums: IDeviceType[] = [
  {
    key: EDeviceTypes.DEVICETYPE_UNKNOWN.toString(),
    text: 'Unknown Device Type',
  },
  {
    key: EDeviceTypes.PERSONAL_COMPUTER.toString(),
    text: 'Desktop',
  },
  {
    key: EDeviceTypes.CONNECTED_TV.toString(),
    text: 'Connected TV',
  },
  {
    key: EDeviceTypes.MOBILE.toString(),
    text: 'Mobile',
  },
  {
    key: EDeviceTypes.TABLET.toString(),
    text: 'Tablet',
  },
  {
    key: EDeviceTypes.CONNECTED_DEVICE.toString(),
    text: 'Connected Device',
  },
  {
    key: EDeviceTypes.SET_TOP_BOX.toString(),
    text: 'Set-Top Box',
  },
];

export function createAllDeviceTypesAsEnumMenuList(): IMenuList {
  const out = {} as IMenuList;
  allDeviceTypeEnums.forEach((dT) => {
    out[dT.key] = {
      ID: dT.key,
      selected: false,
      title: dT.text,
    };
  });
  return out;
}
